import type { CategoryItem, CategoryTree } from '~/types/searchTypes'

function build(currentCategory: CategoryItem | null, categories: CategoryItem[]): CategoryTree[] {
  const workingCategories: CategoryItem[] = categories.filter((category) => {
    if (currentCategory === null) {
      return category.parent_id === null
    }

    return category.parent_id === currentCategory.id
  })

  const workingCategoryIds = new Set(workingCategories.map((workingCategory) => workingCategory.id))

  const remainingCategories = categories.filter((category) => !workingCategoryIds.has(category.id))

  return workingCategories
    .map((category) => ({
      ...category,
      children: build(category, remainingCategories),
    }))
    .sort((a, b) => a.position - b.position)
}

export default build
